"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _header = _interopRequireDefault(require("../header"));

var _Table = _interopRequireDefault(require("../../preact-components/table/Table"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _permissions = require("@insided/deprecated-preact-components/utils/permissions");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _ConfirmationModal = _interopRequireDefault(require("@insided/shared/uikit/Modal/ConfirmationModal"));

var _PauseSystemEmailsModal = _interopRequireDefault(require("./PauseSystemEmailsModal"));

var _message = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/message"));

var _axios = _interopRequireDefault(require("axios"));

var _logger = require("@insided/shared/services/logger");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var EmailTemplate = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(EmailTemplate, _Component);

  var _super = _createSuper(EmailTemplate);

  function EmailTemplate(props) {
    var _this;

    (0, _classCallCheck2.default)(this, EmailTemplate);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "openDisablingModal", function () {
      _this.setState({
        isDisablingModalOpen: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "closeDisablingModal", function () {
      _this.setState({
        isDisablingModalOpen: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "openEnablingModal", function () {
      _this.setState({
        isEnablingModalOpen: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "closeEnablingModal", function () {
      _this.setState({
        isEnablingModalOpen: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "enableSystemEmails", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.setState({
                isLoading: true,
                isEnablingModalOpen: false
              });

              _context.prev = 1;
              _context.next = 4;
              return _axios.default.post('/email/system-emails/enable');

            case 4:
              _this.setState({
                isLoading: false,
                systemEmailsDisabled: false,
                alertMessage: 'All system emails has been resumed successfully!',
                alertType: 'success'
              });

              _context.next = 11;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](1);

              _logger.logger.error(_context.t0, {
                component: 'EmailTemplate',
                action: 'enableSystemEmails'
              });

              _this.setState({
                isLoading: false,
                alertMessage: 'An error occurred while enabling system emails. Please try again later.',
                alertType: 'error'
              });

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 7]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "disableSystemEmails", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.setState({
                isLoading: true,
                isDisablingModalOpen: false
              });

              _context2.prev = 1;
              _context2.next = 4;
              return _axios.default.post('/email/system-emails/disable');

            case 4:
              _this.setState({
                isLoading: false,
                systemEmailsDisabled: true,
                alertMessage: 'All system emails has been paused successfully!',
                alertType: 'success'
              });

              _context2.next = 11;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](1);

              _logger.logger.error(_context2.t0, {
                component: 'EmailTemplate',
                action: 'disableSystemEmails'
              });

              _this.setState({
                isLoading: false,
                alertMessage: 'An error occurred while pausing system emails. Please try again later.',
                alertType: 'error'
              });

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 7]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "dismissAlert", function () {
      _this.setState({
        alertMessage: undefined,
        alertType: undefined
      });
    });
    _this.state = {
      systemEmailsDisabled: props.systemEmailsDisabled,
      isDisablingModalOpen: false,
      isEnablingModalOpen: false,
      isLoading: false,
      alertMessage: undefined,
      alertType: undefined
    };
    return _this;
  }

  (0, _createClass2.default)(EmailTemplate, [{
    key: "render",
    value: function render() {
      var emailList = this.props.emailList;
      var _this$state = this.state,
          systemEmailsDisabled = _this$state.systemEmailsDisabled,
          isDisablingModalOpen = _this$state.isDisablingModalOpen,
          isEnablingModalOpen = _this$state.isEnablingModalOpen,
          isLoading = _this$state.isLoading,
          alertMessage = _this$state.alertMessage,
          alertType = _this$state.alertType;
      var model = [{
        header: 'Template',
        accessor: 'title'
      }, {
        header: 'Email trigger',
        accessor: 'description'
      }, {
        header: 'Action',
        accessor: 'action'
      }];
      var rows = emailList.map(function (email) {
        return {
          title: (0, _preact.h)("div", null, email.title),
          description: (0, _preact.h)("div", null, email.description),
          action: (0, _preact.h)("a", {
            href: (0, _absoluteUrlRuntime.resolveUrl)("/email/system-emails/edit?type=".concat(email.type)),
            "data-track-type": "click",
            "data-element-name": "edit link"
          }, (0, _preact.h)(_Button.default, {
            title: "Edit",
            variant: "secondary"
          }))
        };
      });

      var _getInsidedData = (0, _insidedDataStorage.getInsidedData)('user'),
          mainRole = _getInsidedData.mainRole;

      var customButtons = [];

      if ([_permissions.SUPER_ADMIN, _permissions.ADMINISTRATOR].includes(mainRole)) {
        if (systemEmailsDisabled) {
          customButtons.push((0, _preact.h)(_Button.default, {
            disabled: isLoading,
            title: "Resume All Emails",
            variant: "secondary",
            onClick: this.openEnablingModal,
            key: "enable-system-emails"
          }));
        } else {
          customButtons.push((0, _preact.h)(_Button.default, {
            disabled: isLoading,
            title: "Pause All Emails",
            variant: "secondary",
            onClick: this.openDisablingModal,
            key: "disable-system-emails"
          }));
        }
      }

      return (0, _preact.h)("div", {
        className: "email-templates-list",
        "data-bounded-context": "Emails",
        "data-entity": "email-templates"
      }, (0, _preact.h)(_header.default, {
        title: "System Emails",
        disableSaveButton: true,
        disableCancelButton: true,
        customButtons: customButtons
      }), (0, _preact.h)(_PauseSystemEmailsModal.default, {
        onPauseClick: this.disableSystemEmails,
        onClose: this.closeDisablingModal,
        isOpen: isDisablingModalOpen
      }), (0, _preact.h)(_ConfirmationModal.default, {
        isOpen: isEnablingModalOpen,
        handleConfirmation: this.enableSystemEmails,
        onClose: this.closeEnablingModal,
        title: "Resume all system emails?",
        body: "This will resume ALL system emails, including replies, subscriptions, password reset emails and account confirmation emails.",
        variant: "brand",
        action: (0, _absoluteUrlRuntime.resolveUrl)("Resume")
      }), alertMessage && (0, _preact.h)(_message.default, {
        variant: alertType,
        message: alertMessage,
        isControl: true,
        timer: 5000,
        onDismiss: this.dismissAlert
      }), (0, _preact.h)(_Table.default, {
        model: model,
        rows: rows,
        narrow: true
      }));
    }
  }]);
  return EmailTemplate;
}(_preact.Component);

var _default = EmailTemplate;
exports.default = _default;